module.exports = __webpack_public_path__ + "img/gambar store roomi ex (2).782d09c8.png";